import api from '@/js/services/api';

export default {

    delete(id) {
        return api().delete(`/master-admin/settings/status/${id}/delete`);
    },
    saveNewStage(stage) {
        return api().post(`/master-admin/settings/status/store`, stage)
    },

    updateStatus(id, stage) {
        return api().post(`/master-admin/settings/status/${id}/update`, stage)
    },
    getListOfStatuses() {
        return api().get(`/master-admin/settings/status/get`)
    },

    updateStatusForApplicant(status_id, payload) {
        return api().post(`/master-admin/settings/status/user/${status_id}/update`, payload)
    },

    saveStatusForApplicant(payload) {
        return api().post(`/master-admin/settings/status/store/user/item`, payload)
    },

    updateStagePosition(pending,active) {
        return api().post(`/master-admin/settings/status/change`, {pending,active })
    }

}
